<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="row justify-content-between align-items-center mb-2 zIndexUp">
      <h4 class="col-xl-auto col-lg-auto col-md-6 col-sm-6 mb-lg-0 mb-sm-2 mb-md-2 mb-2">Order Review</h4>
      <ul
        class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
        <li *ngIf="permission.OrderReview_Filter == 1 || roleId==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-info border-info" (click)="toggleFilter()"><span
              class="mdi mdi-filter"></span>
            Filter</a></li>
        <li *ngIf="permission.OrderReview_Add == 1 || roleId==1"> <a href="javascript:void(0);"
            routerLink="/orderReview/orderaddupdate" class="btn btn-sm btn-light-info"><span
              class="mdi mdi-plus"></span>
            Add Order Review</a></li>
      </ul>
    </div>
    <div class="card mt-3" *ngIf="isCollapsed">
      <div class="card-body cb-pad-adjust">
        <form [formGroup]="filterForm">
          <div class="form-row">

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <small>Project Name (Project ID)</small>
              <angular2-multiselect formControlName="ProjectId" [data]="showProject" [(ngModel)]="selectedProject"
                [settings]="dropdownSetting1" (onSelect)="onProjectSelect($event)"
                (onDeSelect)="onProjectSelect($event)" (onSelectAll)="onProjectSelect($event)"
                (onDeSelectAll)="onProjectSelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <small>Inquiry Name (Inquiry ID)</small>
              <angular2-multiselect formControlName="InquiryId" [settings]="dropdownSetting2" [data]="showInquiry"
                [(ngModel)]="selectedinquiry" (onSelect)="onInquirySelect($event)"
                (onDeSelect)="onInquirySelect($event)" (onSelectAll)="onInquirySelect($event)"
                (onDeSelectAll)="onInquirySelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <small>Customer Name</small>
              <angular2-multiselect formControlName="CustomerId" [settings]="dropdownSetting3" [data]="showCustomer"
                [(ngModel)]="selectedcustomer" (onSelect)="onCustomerSelect($event)"
                (onDeSelect)="onCustomerSelect($event)" (onSelectAll)="onCustomerSelect($event)"
                (onDeSelectAll)="onCustomerSelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>


            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <small>Critical Shipment</small>
              <angular2-multiselect [data]="dropdownList1" [(ngModel)]="selectedItems" [settings]="dropdownSetting"
                formControlName="CriticalShipment" (onSelect)="onCriticalSelect($event)"
                (onDeSelect)="onCriticalSelect($event)" fixSearchBug></angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <small>Stages</small>
              <angular2-multiselect formControlName="Stage" [settings]="dropdownSetting4" [data]="showStage"
                [(ngModel)]="selectedstage" (onSelect)="onStageSelect($event)" (onDeSelect)="onStageSelect($event)"
                (onSelectAll)="onStageSelect($event)" (onDeSelectAll)="onStageSelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <small>SO Options</small>
              <angular2-multiselect [data]="SoOption" formControlName="SOOption" [(ngModel)]="selectedSo"
                [settings]="dropdownSo" (onSelect)="onSoSelect($event)"
                (onDeSelect)="onSoDeSelect($event)"></angular2-multiselect>
            </div>

            <div class="col-xl-2 date-filter-field-2 date-filter-second-last-field col-lg-6 mb-2">
              <small class="d-flex align-items-center">Equipment Delivery Date</small>
              <div class="input-group">
                <div class="w-100 position-relative">
                  <input class="form-control" formControlName="EquipmentDeliveryDate" type="text" [showDropdowns]="true"
                    ngxDaterangepickerMd [(ngModel)]="date_range" [settings]="dropdownSettings"
                    [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                    (keydown)="disableDate()" [showClearButton]="true" placeholder="DD-MM-YYYY"
                    [ngModelOptions]="{standalone: true}" />
                  <sapn class="position-absolute" style="top: 48%; right: -5px; transform: translate(-50%, -50%);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
                      viewBox="0 0 16 16" (click)="clearStartDate()">
                      <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                  </sapn>
                </div>
              </div>
            </div>

            <div class="col-xl-2 date-filter-field-2 date-filter-last-field col-lg-6 mb-3 mb-xl-2">
              <small class="d-flex align-items-center">Target Completion Date</small>
              <div class="input-group">
                <div class="w-100 position-relative">
                  <input class="form-control" formControlName="TargetCompletionDate" type="text" [showDropdowns]="true"
                    ngxDaterangepickerMd (keydown)="disableDate()" [(ngModel)]="date_range2"
                    [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                    [ngModelOptions]="{standalone: true}" [showClearButton]="true" placeholder="DD-MM-YYYY" />
                  <sapn class="position-absolute" style="top: 48%; right: -5px; transform: translate(-50%, -50%);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
                      viewBox="0 0 16 16" (click)="clearEndDate()">
                      <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                  </sapn>
                </div>
              </div>
            </div>

            <div class="col-auto mt-md-3">
              <div class="mb-2 pt-2">
                <button href="javascript:void(0);"
                  class="btn btn-outline-info d-flex align-items-center btn-new-light-info" title="Apply"
                  (click)="onSubmit()" [disabled]="multiClick">
                  <i class="mdi mdi-checkbox-marked-outline mdi-18px" [disabled]="multiClick"></i>Apply</button>
              </div>
            </div>
            <div class="col-auto mt-0 mt-md-3">
              <div class="mb-2 pt-2">
                <a href="javascript:void(0);" class="btn btn-outline-info d-flex align-items-center btn-new-light-info"
                  title="Reset" (click)="resetData()">
                  <i class="mdi mdi-reload mdi-18px"></i></a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
            style="width: 250px !important; float: right;">
            <input #inputField matInput class="text-limit  pos-search" [(ngModel)]="searchword" placeholder="Search"
              (keyup.enter)="applyFilter()" />
            <span class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
              style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;" (click)="applyFilter();">
            </span>
            <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
              title="Clear">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16" (click)="clearUserData(); applyFilter()" (clearEvent)="searchword=''"
                *ngIf="searchword">
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
          </mat-form-field>
          <table class="table table-mini-th" mat-table matSorts [dataSource]="dataSource" matSort
            [matSortActive]="'name'" [matSortDisableClear]="true" [matSortDirection]="'asc'"
            [multiTemplateDataRows]="true" (matSortChange)="onSortData($event)" aria-hidden="true">
            <ng-container matColumnDef="ProjectName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;max-width: 200px;"
                class="p-1 font-12">Project Name
                (Project Id)<img src="assets/images/sort_both.png" *ngIf="columnsort!='ProjectName'" alt=""><img
                  src="assets/images/sort_up.png" alt="" *ngIf="upicon && !downicon && columnsort =='ProjectName'"><img
                  src="assets/images/sort_down.png" alt="" *ngIf="downicon && !upicon && columnsort =='ProjectName'">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">{{element['ProjectName']}}
                <br />({{element['ProjectNumber']}})
              </td>
            </ng-container>

            <ng-container matColumnDef="InquiryName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:170px;max-width: 200px;"
                class="p-1 font-12">Inquiry Name
                (Inquiry Id)<img src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='InquiryName'"><img
                  src="assets/images/sort_up.png" alt="" *ngIf="upicon && !downicon && columnsort =='InquiryName'"><img
                  src="assets/images/sort_down.png" alt="" *ngIf="downicon && !upicon && columnsort =='InquiryName'">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">{{element['InquiryName']}}<br />
                ({{element['InquiryNumber']}})
              </td>
            </ng-container>

            <ng-container matColumnDef="CustomerName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12" style="min-width: 150px;
              max-width: 200px;">Customer Name<img src="assets/images/sort_both.png" alt=""
                  *ngIf="columnsort!='CustomerName'"><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='CustomerName'"><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='CustomerName'" alt="">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">{{element['CustomerName']}}</td>
            </ng-container>

            <ng-container matColumnDef="SOOption">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">SO Option<img
                  src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='SOOption'"><img
                  src="assets/images/sort_up.png" *ngIf="upicon && !downicon && columnsort =='SOOption'" alt=""><img
                  src="assets/images/sort_down.png" *ngIf="downicon && !upicon && columnsort =='SOOption'" alt="">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">
                {{element['SOOptionName']}}</td>
            </ng-container>

            <ng-container matColumnDef="MTINumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">MTI Number<img
                  src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='MTINumber'"><img
                  src="assets/images/sort_up.png" *ngIf="upicon && !downicon && columnsort =='MTINumber'" alt=""><img
                  src="assets/images/sort_down.png" *ngIf="downicon && !upicon && columnsort =='MTINumber'" alt="">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }"><a
                  *ngIf="permission.OrderReview_View==1 || roleId==1" href="javascript:void(0);"
                  (click)="view(element.OrderInfoId)">{{ element['MTINumber'] ? element['MTINumber'] : '-' }}</a></td>
            </ng-container>

            <ng-container matColumnDef="Stage">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Stage<img
                  src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='Stages'"><img
                  src="assets/images/sort_up.png" *ngIf="upicon && !downicon && columnsort =='Stages'" alt=""><img
                  src="assets/images/sort_down.png" *ngIf="downicon && !upicon && columnsort =='Stages'" alt="">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">
                {{element['CurrentStageName']}}</td>
            </ng-container>

            <ng-container matColumnDef="Status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Status<img alt=""
                  src="assets/images/sort_both.png" *ngIf="columnsort!='Status'"><img src="assets/images/sort_up.png"
                  *ngIf="upicon && !downicon && columnsort =='Status'" alt=""><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='Status'" alt="">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">
                {{element['StatusName']}}</td>
            </ng-container>

            <ng-container matColumnDef="SOAcknowledgement">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">SO Ack.<img
                  src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='SOAcknowledgement'"><img alt=""
                  src="assets/images/sort_up.png" *ngIf="upicon && !downicon && columnsort =='SOAcknowledgement'"><img
                  src="assets/images/sort_down.png" alt=""
                  *ngIf="downicon && !upicon && columnsort =='SOAcknowledgement'">
              </th>
              <td mat-cell *matCellDef="let element" class="text-right p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">
                {{element['SOAcknowledgementName']}}</td>
            </ng-container>

            <ng-container matColumnDef="EquipmentDeliveryDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;max-width:200px;"
                class="p-1 font-12">Equipment Delivery Date<img src="assets/images/sort_both.png" alt=""
                  *ngIf="columnsort!='EquipmentDeliveryDate'"><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='EquipmentDeliveryDate'"><img
                  src="assets/images/sort_down.png" alt=""
                  *ngIf="downicon && !upicon && columnsort =='EquipmentDeliveryDate'">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">
                {{element['EquipmentDeliveryDate']}}</td>
            </ng-container>

            <ng-container matColumnDef="ProjectTargetCompletionDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;max-width:200px;"
                class="p-1 font-12">ProjectTargetCompletionDate<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='ProjectTargetCompletionDate'" alt=""><img src="assets/images/sort_up.png"
                  *ngIf="upicon && !downicon && columnsort =='ProjectTargetCompletionDate'" alt=""><img
                  src="assets/images/sort_down.png" alt=""
                  *ngIf="downicon && !upicon && columnsort =='ProjectTargetCompletionDate'">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">{{element['ProjectCompletionDate']}}
              </td>
            </ng-container>

            <ng-container matColumnDef="CreatedByName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 80px;" class="p-1 font-12">Created
                BY<img src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='CreatedByName'"><img alt=""
                  src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='CreatedByName'"><img src="assets/images/sort_down.png"
                  alt="" *ngIf="downicon && !upicon && columnsort =='CreatedByName'">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">{{element['CreatedByName']}}</td>
            </ng-container>

            <ng-container matColumnDef="CreatedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Created Date<img
                  src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='CreatedDate'"><img alt=""
                  src="assets/images/sort_up.png" *ngIf="upicon && !downicon && columnsort =='CreatedDate'"><img
                  src="assets/images/sort_down.png" alt="" *ngIf="downicon && !upicon && columnsort =='CreatedDate'">
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12"
                [ngClass]="{ 'red-background': element.CriticalShipment }">{{element['CreatedDate']}}</td>
            </ng-container>

            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef class="p-1 font-12"><span class="mdi mdi-settings"></span>
              </th>
              <td mat-cell *matCellDef="let element" class="p-1 font-12">
                <div ngbDropdown class="d-block list-dropdown-box">
                  <a href="javascript:void(0);" class="text-center d-block" id="dropdownBasic1" ngbDropdownToggle> <i
                      class="mdi mdi-dots-vertical mdi-24"></i></a>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
                    <div class="d-block">

                      <div *ngIf="permission.OrderReview_View==1 || roleId==1">
                        <a href="javascript:void(0);" placement="bottom" ngbTooltip="Detail"
                          (click)="view(element.OrderInfoId)"><button ngbDropdownItem>
                            <i class="mdi mdi-information-outline"></i> Detail
                          </button></a>
                      </div>

                      <div
                        *ngIf="permission.OrderReview_Edit==1 && ((element['QuotationEngineer'] == userId || element['CommercialExecutive'] == userId || element['SalesEngineer'] == userId || element['SalesManager'] == userId || element['FinanceManager'] == userId || element['GeneralManager'] == userId || element['CreatedBy'] == userId) || roleId==1) && (element['CurrentStageName'] != 'PO / Contract Cancelled' && element['CurrentStageName'] != 'Job Closed')">
                        <a href="javascript:void(0);" placement="bottom" ngbTooltip="Edit"
                          (click)="edit(element.OrderInfoId)"><button ngbDropdownItem>
                            <i class="mdi mdi-pencil"></i> Edit
                          </button></a>
                      </div>

                      <div
                        *ngIf="(element['GeneralManager'] == userId || element['FinanceManager'] == userId || element['SalesManager'] == userId || roleId==1) && (element['CurrentStageName'] != 'Draft' && element['CurrentStageName'] != 'PO / Contract Cancelled' && element['CurrentStageName'] != 'Job Closed' && element['StatusName'] != 'Approved')">
                        <a href="javascript:void(0);" placement="bottom"
                          (click)="approveOpenModal(approveConfirm, element)"><button ngbDropdownItem><i
                              class="mdi mdi-thumb-up-outline mdi-18px"></i> Approve</button></a>
                      </div>   

                      <div
                        *ngIf="(element['FinanceManager'] == userId || element['SalesManager'] == userId || roleId==1) && (element['CurrentStageName'] != 'Draft' && element['CurrentStageName'] != 'PO / Contract Cancelled' && element['CurrentStageName'] != 'Job Closed' && element['StatusName'] != 'Approved')">
                        <a href="javascript:void(0);" placement="bottom" ngbTooltip="Forward"
                          (click)="forwardOpenModal(forwardConfirm, element.OrderInfoId, element.ProjectName, element.InquiryName)">
                          <button ngbDropdownItem><i class="mdi mdi-share mdi-18px"></i> Forward</button></a>
                      </div>

                      <div
                        *ngIf="(element['GeneralManager'] == userId || element['FinanceManager'] == userId || element['SalesManager'] == userId || roleId==1) && (element['CurrentStageName'] != 'Draft' && element['CurrentStageName'] != 'PO / Contract Cancelled' && element['CurrentStageName'] != 'Job Closed' && element['StatusName'] != 'Approved')">
                        <a href="javascript:void(0);" placement="bottom" ngbTooltip="Reject"
                          (click)="rejectOpenModal(rejectConfirm, element.OrderInfoId, element.ProjectName, element.InquiryName)"><button
                            ngbDropdownItem><i class="mdi mdi-close-circle-outline mdi-18px"></i> Reject</button></a>
                      </div>

                      <div
                        *ngIf="(permission.OrderReview_Delete==1 || roleId==1) && (element['CurrentStageName'] == 'Pending MTI' || element['CurrentStageName'] == 'Draft')">
                        <a href="javascript:void(0);" placement="bottom" ngbTooltip="Delete"
                          (click)="deleteOpenModal(deleteConfirm, element.OrderInfoId, 3, element.ProjectName, element.InquiryName)"><button
                            ngbDropdownItem><i class="mdi mdi-delete"></i> Delete
                          </button></a>
                      </div>

                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr class="odd" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="TotalRecord == 0" class="text-center">
            No Record found.
          </div>
          <div *ngIf="TotalRecord > 0">
            <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalSize" showFirstLastButtons
              aria-label="Select page of periodic elements" [pageIndex]="currentPage" (page)="handlePage($event)"
              [pageSize]="pageSize">
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Action  Modal-->
<ng-template #approveConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Approve Order</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="decline1(); modalRef.hide();" data-dismiss="modal">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Project Name (Project ID): {{PrName}} ({{Pid}})</strong></p>
    <p class="text-left mb-2"><strong>Inquiry Name (Inquiry ID): {{InqName}} ({{Iid}})</strong></p>
    <p class="text-left mb-2">Are you sure, you want to perform this
      action ?</p>
  </div>
  <div class="modal-footer">
    <a href="javascript:void(0);" (click)="approveOrder(); modalRef.hide()" class="btn btn-success btn">Approve <span
        class="fa fa fa-thumbs-o-up mdi-18px" aria-hidden="true"></span></a>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline1(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<ng-template #rejectConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Reject Order</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="decline2(); modalRef.hide();" data-dismiss="modal">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Project Name: {{PrName}} </strong></p>
    <p class="text-left mb-2"><strong>Inquiry Name: {{InqName}} </strong></p>
    <form [formGroup]="RejectForm">
      <p class="text-left mb-2"><strong>Reason:</strong></p>
      <textarea class="form-control" maxlength="200" formControlName="ResonValue"></textarea>
    </form>
    <p class="text-left mb-2">Are you sure, you want to perform this
      action ?</p>
  </div>
  <div class="modal-footer">
    <a href="javascript:void(0);" (click)="rejectOrder(); modalRef.hide()" class="btn btn-danger btn">Reject <span
        class="fa fa fa-times mdi-18px" aria-hidden="true"></span></a>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline2(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<ng-template #forwardConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Forward Order</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="decline3(); modalRef.hide();" data-dismiss="modal">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Project Name: {{PrName}} </strong></p>
    <p class="text-left mb-2"><strong>Inquiry Name: {{InqName}} </strong></p>
    <form [formGroup]="ForwardForm">
      <p class="text-left mb-2"><strong>Reason:</strong></p>
      <textarea class="form-control" maxlength="200" formControlName="ResonValue"></textarea>
    </form>
    <p class="text-left mb-2">Are you sure, you want to perform this
      action ?</p>
  </div>
  <div class="modal-footer">
    <a href="javascript:void(0);" (click)="forwardOrder(); modalRef.hide()" class="btn btn-primary btn">Forward <span
        class="fa fa fa-share mdi-18px" aria-hidden="true"></span></a>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline3(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<!--Delete modal-->
<ng-template #deleteConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Order Delete</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Project Name: {{PrName}} </strong></p>
    <p class="text-left mb-2"><strong>Inquiry Name: {{InqName}} </strong></p>
    <p class="text-left mb-2">Do you want to delete this Order ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="deleteOrder(); modalRef.hide();"
      [disabled]="delNameDel">Delete</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>